import { useIntl } from "react-intl";

import { useCohort } from "@/components/user-context";

import { LoggedInJsmExistingUser } from "./existing-user";
import { LoggedInJsmNewUser } from "./new-user";

export const LoggedInJsmFree = () => {
    const { formatMessage } = useIntl();
    const cohort = useCohort();

    if (cohort === "new-user") {
        return <LoggedInJsmNewUser />;
    }

    if (cohort) {
        return (
            <LoggedInJsmExistingUser
                productEditionText={formatMessage({
                    id: "WacSignupHeader.cloudFree",
                    defaultMessage: "Cloud Free"
                })}
            />
        );
    }

    return null;
};
